import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';

import CheckoutSummaryDelivery, {
  CheckoutSummaryDeliveryMethodType,
} from './CheckoutSummaryDelivery/CheckoutSummaryDelivery';
import CheckoutSummaryList from './CheckoutSummaryList/CheckoutSummaryList';
import CheckoutSummaryTotal from './CheckoutSummaryTotal/CheckoutSummaryTotal';
import Loader from 'components/Common/Loader/Loader';
import { cartContext } from 'contexts/cartContext';

import styles from './CheckoutSummary.module.scss';

export default function CheckoutSummary({
  classes,
}: CheckoutSummaryType): JSX.Element {
  const { t } = useTranslation(['checkout', 'translation']);
  const { cart } = useContext(cartContext);

  if (!cart) {
    return (
      <div className={classNames(classes?.wrapper)}>
        <Loader />
      </div>
    );
  }

  return (
    <div className={classNames(classes?.wrapper)}>
      <p className={styles.title}>
        {t('LABEL_SUMMARY', { ns: 'translation' })}
        <span>{`(${t('LABEL_NUMBER_ITEMS', {
          count: cart.nbProducts,
        })})`}</span>
      </p>
      {cart.deliveryMethod?.delivery && (
        <CheckoutSummaryDelivery
          method={cart.deliveryMethod as CheckoutSummaryDeliveryMethodType}
        />
      )}
      <CheckoutSummaryList
        products={cart.products}
        specialOffers={cart.selectedSpecialOffers}
        gifts={cart.selectedOfferedGifts}
      />
      <CheckoutSummaryTotal cart={cart} />
      <div id={'checkout-sidebar-after'} />
    </div>
  );
}

type CheckoutSummaryType = {
  classes?: CheckoutSummaryClassesType;
};

type CheckoutSummaryClassesType = {
  wrapper?: string;
};
